import clsx from "clsx";
import { FC } from "react";
import { Icon } from "react-migration/components/Icon";
import { formatDate } from "react-migration/domains/comparables/util/Dates";
import { OwnershipTags } from "./OwnershipTags";
import { EnhancedTransaction } from "react-migration/domains/comparables/hooks/useComparablePrices";

interface CompsListingProps {
  transaction: EnhancedTransaction;
  onSelected: () => void;
}

export const CompsListing: FC<CompsListingProps> = ({ transaction, onSelected }) => {
  const { address, date_of_transfer: dateOfRecord, formattedPrice, formattedPerAreaPrice } = transaction;

  return (
    <div className="overflow-hidden border border-solid rounded-md border-neutral-200">
      <button
        className={clsx("cursor-pointer w-full p-2 bg-white flex flex-col gap-1")}
        data-testid="comps-listing"
        onClick={onSelected}
        onKeyDown={onSelected}
      >
        <div className={clsx("comps-listing-header flex flex-row items-center justify-between")}>
          <div
            className={clsx(
              "comps-listing-header-left flex flex-row gap-4 items-center",
              formattedPrice === "N/A" && "text-blue-grey-600a"
            )}
            data-testid="comps-listing-header-left"
          >
            <CompsListingPrice price={formattedPrice} />
            {formattedPerAreaPrice && <CompsListingPriceMode price={formattedPerAreaPrice} />}
          </div>
          <div className="flex flex-row items-center gap-2 comps-listing-header-right">
            <Icon icon="icon-lt-arrow-right-s-line" size="lg" />
          </div>
        </div>
        <div className="comps-listing-address" data-testid="comps-listing-address">
          <span className="block text-sm font-medium text-left capitalize text-blue-grey-950">{address}</span>
        </div>
        <div className="flex flex-row items-center justify-between mt-1 comps-listing-footer gap-2">
          <OwnershipTags transaction={transaction} />

          <div className="comps-listing-date-of-record">
            <span className="block text-xs text-neutral-500">{dateOfRecord ? formatDate(dateOfRecord) : ""}</span>
          </div>
        </div>
      </button>
    </div>
  );
};

function CompsListingPrice({ price }: { price?: string }) {
  if (price === undefined) {
    return null;
  }

  return (
    <div className="comps-listing-price" data-testid="comps-listing-price">
      <span title={price.toString()} className="block text-lg font-bold">
        {price}
      </span>
    </div>
  );
}

function CompsListingPriceMode({ price }: { price?: string }) {
  if (price === undefined) return null;

  return (
    <div className="comps-listing-floor-area" data-testid="comps-listing-price-per-area">
      <span className="block text-xs">{price}</span>
    </div>
  );
}
